const registerLogIn = function(){
	const forms = new forms4i();
	const isRegistrationPage = document.getElementsByClassName("RegistrationForm")[0];
	const verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
	const submitBtn = document.getElementById("btnSubmit");
	let allSaleChecks, allProductChecks, allNewsChecks;	
	
	const init = () =>{
		if(isRegistrationPage){
			const zipCode = document.getElementById("ZipCode");
			if(zipCode) maskZipCode(zipCode);
			
			maskPhoneNumbers();
			getAllCheckboxes();	
			
			if(submitBtn){
				const registerForm = document.getElementById("registerForm");
				registerForm.addEventListener("submit", disableBtn);
			}
		}
		
		const submitSMSCode = document.getElementById("submitSMSVerifyCode");
		if(submitSMSCode) submitSMSCode.addEventListener("click", verify);
		
		if(submitBtn) submitBtn.addEventListener("click", submitForm);
	};

	const getAllCheckboxes = () =>{
		const saleSection = document.getElementById("SaleSection");
		if (saleSection) allSaleChecks = saleSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
		
		const productSection = document.getElementById("ProductSection");
		if (productSection) allProductChecks = productSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
		
		const newsSection = document.getElementById("NewsletterSection");		
		if (newsSection && newsSection.getElementsByTagName('ul').length > 0) allNewsChecks = newsSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
	};
	
	const maskZipCode = (zipCode) =>{
		const zipMask = document.getElementById("ZipCodeMask");
		if (zipMask) {
			const zipCodeMaskPattern = zipMask.value;
			// only used for CA
			if (zipCodeMaskPattern != "") VMasker(zipCode).maskPattern(zipCodeMaskPattern);
		}
	};
	
	const maskPhoneNumbers = () => {
		const phoneMask = document.getElementById("phoneMask");
		forms.MaskPhoneNumber(phoneMask, document.getElementById("Phone"));
		forms.MaskPhoneNumber(phoneMask, document.getElementById("MobileNumber"));
	};
	
	const disableBtn = () =>{
		submitBtn.disabled = true;
	};
	
	const verify = (e) => {
		const codeInput = document.getElementById('code');
		if (codeInput.value == "") {
			e.preventDefault();
			const errorBox = document.getElementById("ErrorBox");
			if (errorBox) errorBox.remove();
			const errorMsg = document.getElementsByClassName("errorMessage")[0];
			errorMsg.classList.remove("hide");
			codeInput.classList.add("input-validation-error");
			codeInput.setAttribute("aria-invalid", "true");
		}
	};
	
	const submitForm = (e) =>{
		 // using this ID on all forms in registration
		const registerForm = document.getElementById("registerForm");
		if(registerForm) forms.formValidation(registerForm, formSuccess, e);
	};
	
	const formSuccess = () => {	
		const email = document.getElementById('Email');
		const registerForm = document.getElementsByClassName("RegistrationForm")[0];
		if (email && registerForm) saveEmailPreferences(email.value);
    	};
    	
    	const getPrefs = (elements) =>{
		let emailPrefs = "";
		for(let i = 0; i < elements.length; i++){
			if(elements[i].value != ''){
				if(elements[i].checked) emailPrefs += elements[i].value + ":true,";
				else emailPrefs += elements[i].value + ":false,";
			}
		}
		return emailPrefs;
	};
    	
    	const saveEmailPreferences = async (emailAddress) =>{
		const salePrefs = getPrefs(allSaleChecks);
		const productPrefs = getPrefs(allProductChecks);
		const newsPrefs = getPrefs(allNewsChecks);
		const emailPreferences = salePrefs + productPrefs + newsPrefs;
		const newUserData = { emailPrefs : emailPreferences, emailAddress : emailAddress };
						
		try{
			const response = await fetch('/Esp/SaveNewUserSubscriptions', { 
				method: 'POST', 
				body: JSON.stringify(newUserData), 
				headers: { 
					'Content-Type': 'application/json', 
					'X-Requested-With': 'fetch', 
					"__RequestVerificationToken": verificationToken, 
					"RequestVerificationToken": verificationToken 
				}
			});
			
			if(!response.ok) throw new Error("Error processing new user subscription request");
		}catch(error){
			console.log(error);
		}       	
	};
		
	return{
		Init: init
	};
};

(async () =>{
	const validateRegForms = new registerLogIn();
	validateRegForms.Init();

})();